import { useLinkTo } from '@react-navigation/native';
import { RootStackScreenProps } from 'navigation/AppNavigator';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { calcSizeForDevice } from 'utils/index';

import NewGradientButton from 'components/Button/NewGradienteButton';

type Props = RootStackScreenProps<'Program'>;

const RestrictedScreen: React.FC<Props> = () => {
  const linkTo = useLinkTo();

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Conteúdo restrito</Text>
      <Text style={styles.description}>Sua faixa etária não permite acesso a esta área.</Text>
      <View style={styles.buttonWrapper}>
        <NewGradientButton
          useTVFocus
          hasTVPreferredFocus
          onPress={() => linkTo('/')}
          style={styles.button}>
          <Text style={styles.buttonText}>Voltar pra Home</Text>
        </NewGradientButton>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: calcSizeForDevice(16, 32),
  },
  title: {
    fontSize: calcSizeForDevice(20, 28),
    fontWeight: 'bold',
    color: '#FFFFFF',
    marginBottom: calcSizeForDevice(8, 12),
    textAlign: 'center',
  },
  description: {
    fontSize: calcSizeForDevice(16, 22),
    color: '#FFFFFF',
    opacity: 0.8,
    textAlign: 'center',
    marginBottom: calcSizeForDevice(24, 32),
  },
  buttonWrapper: {
    width: '60%',
    maxWidth: 334,
  },
  button: {
    height: 48,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonText: {
    fontWeight: 'bold',
    color: '#070d31',
    textTransform: 'uppercase',
    fontSize: calcSizeForDevice(14, 16),
  },
});

export default RestrictedScreen;
